import React from "react";
const IconWeight = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="56" height="56" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56 56" {...props}>
    <path
      d="M14.336 21.67 38.09 45.427c2.375 2.376 5.94 2.77 8.315.394 2.375-2.375 1.98-5.938-.396-8.314l-3.166-3.166M14.336 21.67l7.92-7.92m-7.92 7.92-1.583 1.585-3.167-3.167L20.672 9l3.167 3.167-1.583 1.583m0 0 4.751 4.752m0 0-3.168 3.169m3.168-3.169 3.959 3.96m-4.752 4.752 4.752-4.752m0 0 3.959 3.959m-3.168 3.168 3.168-3.168m0 0 3.959 3.96m-4.752 4.751 4.752-4.752m0 0 1.055 1.056m-.265 6.072 3.168-3.169m0 0-2.903-2.903m-16.524-.686c1.585-1.833 5.529-.37 7.918.686 2.799 1.236 7.167 1.481 8.606 0m-29.161 0C9.25 33.892 8 36.493 8 37.505c0 3.758 5.555 3.758 5.555 0 0-1.012-1.25-3.613-2.777-6.07Z"
      stroke="currentColor"
      strokeWidth="2"
    />
  </svg>
);
export default IconWeight;
